import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API_END_POINTS } from '../constant/api.constant';
import { environment } from 'src/environments/environment';
import { DialogService } from './dialog.service';
import { AuthService } from './auth.service';
import { BehaviorSubject, Observable, Subject, takeUntil, timer } from 'rxjs';
import { FireAnalyticsService } from './fire-analytics.service';
import { WindowRef } from './shared.service';

declare let cordova: any;

@Injectable({
  providedIn: 'root',
})
export class BrokrageService {

  callbackPage: string = '_callback';
  _unsubscribeAll: Subject<any> = new Subject()
  private brokerDetailsChanged: BehaviorSubject<any> = new BehaviorSubject(null)
  constructor(
    private http: HttpClient,
    private router: Router,
    private ngZone: NgZone,
    private dialogService: DialogService,
    private auth: AuthService,
    private analytics: FireAnalyticsService,
    private windowRef: WindowRef,
    private activatedRoute: ActivatedRoute
  ) {
  }
  // goToGoogleLogin() {
  //   let path: string = this.getCurrentPath();
  //   const uri = `${API_END_POINTS.SL.google}?state=${this.callbackPage}`;
  //   this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'google');
  //   this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
  //   if (environment.app) {
  //     cordova.InAppBrowser.open(uri, '_system', 'location=yes');
  //   } else {
  //     this.windowRef.nativeWindow?.open(uri, "_self");
  //   }
  // }
  // getGoogleInfo(token: any): Observable<any> {
  //   return this.http.post(`${API_END_POINTS.SL.googleDecode}`, {
  //     token: token,
  //   });
  // }
  private goToAliceBlue() {
    let path: string = this.getCurrentPath();
    const uri = `${API_END_POINTS.ALICE_BLUE.client}?state=${this.callbackPage}&type=siginin`;
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'alice_blue');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    if (environment.app) {
      cordova.InAppBrowser.open(uri, '_system', 'location=yes');
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }
  getAliceBlueTokenInfo(token: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.ALICE_BLUE.token_info}?token=${token}`);
  }
  aliceBlueLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ALICE_BLUE.loginWith, data);
  }
  aliceBlueSignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ALICE_BLUE.signinWith, data);
  }
  private goToMasterTrust() {
    let path: string = this.getCurrentPath();
    const uri = `${API_END_POINTS.MASTER_TRUST.client}?state=${this.callbackPage}&type=siginin`;
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'master_trust');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    if (environment.app) {
      cordova.InAppBrowser.open(uri, '_system', 'location=yes');
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }
  getMasterTrustTokenInfo(token: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.MASTER_TRUST.token_info}?token=${token}`);
  }
  masterTrustLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.MASTER_TRUST.loginWith, data);
  }
  masterTrustSignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.MASTER_TRUST.signinWith, data);
  }
  private goToFivePaisa() {
    let path: string = this.getCurrentPath();
    const uri = `${API_END_POINTS.FIVE_PAISA.client}?state=${this.callbackPage}`;
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'five_paisa');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    if (environment.app) {
      cordova.InAppBrowser.open(uri, '_system', 'location=yes');
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }
  getFivePaisaTokenInfo(token: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.FIVE_PAISA.token_info}?token=${token}`);
  }
  fivePaisaLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.FIVE_PAISA.loginWith, data);
  }
  fivePaisaSignIn(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.FIVE_PAISA.signinWith}`, data);
  }
  private goToKleverTrade() {
    let path: string = this.getCurrentPath();
    const uri = `${API_END_POINTS.KLEVER_TRADE.client}?state=${this.callbackPage}&type=siginin`;
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'klever_trade');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    if (environment.app) {
      cordova.InAppBrowser.open(uri, '_system', 'location=yes');
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }
  getKleverTradeInfo(token: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.KLEVER_TRADE.token_info}?token=${token}`);
  }
  kleverTradeLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.KLEVER_TRADE.loginWith, data);
  }
  kleverTradeSignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.KLEVER_TRADE.signinWith, data);
  }
  private goToZerodha() {
    this.http.get(API_END_POINTS.ZERODHA.client).subscribe({
      next: (res: any) => {
        if (res && res.data) {
          let path: string = this.getCurrentPath();
          this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'zerodha');
          this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
          if (environment.app) {
            const encodedUrl = encodeURIComponent(res.data)
            const userVertical = this.windowRef.nativeWindow?.localStorage.getItem('userVertical')
            const url = `https://pickright.in/callback/kite?type=redirect&page=${path}&redirect_uri=${encodedUrl}&userVertical=${userVertical}`
            if (environment.ios) {
              cordova.InAppBrowser.open(url, '_system', 'location=yes');
            } else {
              const browser = cordova.InAppBrowser.open(url, '_blank', 'location=yes');
              browser.addEventListener('loadstart', (event) => {
                const intentPath = "http://intent://pickright.page.link/?link="
                if (event.url.includes(intentPath)) {
                  const decodePath = decodeURIComponent(event.url.substring(intentPath.length, event.url.indexOf("&apn")));
                  const route = decodePath.replace("https://pickright.in", "")
                  browser.close();
                  this.router.navigateByUrl(`${route}`);
                }
              });
            }
          } else {
            this.windowRef.nativeWindow?.open(res.data, '_self');
          }
        }
      }
    })
  }
  getZerodhaTokenInfo(token: any): Observable<any> {
    return this.http.post(API_END_POINTS.ZERODHA.user_details, { requestToken: token });
  }
  zerodhaLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ZERODHA.loginWith, data);
  }
  zerodhaSignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ZERODHA.signinWith, data);
  }
  private goToAdityaBirla() {
    let path: string = this.getCurrentPath();
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'aditya_birla');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    let uri = ''
    if (environment.production) {
      uri = `${API_END_POINTS.ADITYA_BIRLA.client}?state=${this.callbackPage}`;
    } else {
      uri = `${API_END_POINTS.ADITYA_BIRLA.client}?state=${this.callbackPage}&origin=${environment.webUrl}`;
    }
    if (environment.app) {
      // cordova.InAppBrowser.open(uri, '_system', 'location=yes');
      const url = `${environment.webUrl}/callback/aditya-birla?type=redirect&page=_callback`
      if (environment.ios) {
        cordova.InAppBrowser.open(url, '_system', 'location=yes');
      } else {
        const browser = cordova.InAppBrowser.open(url, '_blank', 'location=yes');
        this.ngZone.runOutsideAngular(() => {
          this.ngZone.run(() => {
            browser.addEventListener('loadstart', (event) => {
              let intentPath = ''
              if (environment.production) {
                intentPath = "http://intent://pickright.page.link/?link="
              } else {
                intentPath = "https://pickright.in"
              }
              if (event.url.includes(intentPath)) {
                const decodePath = decodeURIComponent(event.url.replace(intentPath, ""));
                const route = decodePath.replace('https://pickright.in', "")
                browser.close();
                this.router.navigateByUrl(`${route}`);
              }
            });
          })
        })
      }
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }
  getAdityaBirlaTokenInfo(token: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.ADITYA_BIRLA.token_info}?authCode=${token}`);
  }
  adityaBirlaLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ADITYA_BIRLA.loginWith, data);
  }
  adityaBirlaSignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ADITYA_BIRLA.signinWith, data);
  }
  private goToEdelweiss() {
    let path: string = this.getCurrentPath();
    const uri = `${API_END_POINTS.EDELWEISS.client}?state=${this.callbackPage}`;
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'nuvama');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    if (environment.app) {
      const appURl = `${environment.webUrl}/edelweiss/callback?isMobile=true`
      if (environment.ios) {
        cordova.InAppBrowser.open(appURl, '_system', 'location=yes');
      } else {
        const browser = cordova.InAppBrowser.open(appURl, '_blank', 'location=yes');
        this.ngZone.runOutsideAngular(() => {
          this.ngZone.run(() => {
            browser.addEventListener('loadstart', (event) => {
              let intentPath = 'http://intent://pickright.page.link/?link='
              if (event.url.includes(intentPath)) {
                const decodePath = decodeURIComponent(event.url.replace(intentPath, ""));
                const route = decodePath.replace(environment.webUrl, "")
                browser.close();
                this.router.navigateByUrl(`${route}`);
              }
            });
          })
        })
      }
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }
  // getEdelweissTokenInfo(token: string, userid: string): Observable<any> {
  //   return this.http.get(API_END_POINTS.EDELWEISS.token_info, {headers : {token, userid}});
  // }
  edelweissLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.EDELWEISS.loginWith, data);
  }
  edelweissSignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.EDELWEISS.signinWith, data);
  }
  edelweissSigninV2(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.EDELWEISS.signinWithV2, data);
  }
  private goToAngelBroking() {
    let path: string = this.getCurrentPath();
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'angel_broking');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    const uri = `${API_END_POINTS.ANGELBROKING.client}?state=${this.callbackPage}`;
    if (environment.app) {
      cordova.InAppBrowser.open(uri, '_system', 'location=yes');
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }
  getAngelBrokingTokenInfo(token: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.ANGELBROKING.token_info}?token=${token}`);
  }
  angelBrokingLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ANGELBROKING.loginWith, data);
  }
  angelBrokingSignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ANGELBROKING.signinWith, data);
  }

  private goToBajajFinance() {
    let path: string = this.getCurrentPath();
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'bajaj_finserv');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    const uri = `${API_END_POINTS.BAJAJFINANCE.client}?state=${this.callbackPage}`;
    if (environment.app) {
      const url = `${environment.webUrl}/callback/bajajfinserv?type=redirect&page=_callback`
      if (environment.ios) {
        cordova.InAppBrowser.open(url, '_system', 'location=yes');
      } else {
        const browser = cordova.InAppBrowser.open(url, '_blank', 'location=yes');
        this.ngZone.runOutsideAngular(() => {
          this.ngZone.run(() => {
            browser.addEventListener('loadstart', (event) => {
              let intentPath = 'http://intent://pickright.page.link/?link='
              if (event.url.includes(intentPath) && !event.url.includes('bajajfinservsecurities')) {
                const decodePath = decodeURIComponent(event.url.replace(intentPath, ""));
                const route = decodePath.replace(environment.webUrl, "")
                browser.close();
                this.router.navigateByUrl(`${route}`);
              }
            });
          })
        })
      }
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }

  getBajajFinanceTokenInfo(token: any): Observable<any> {
    return this.http.get(`${API_END_POINTS.BAJAJFINANCE.token_info}?req_token=${token}`);
  }

  bajajFinanceSignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.BAJAJFINANCE.signinWith, data);
  }

  bajajFinanceLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.BAJAJFINANCE.loginWith, data);
  }

  private goToTradeSmart() {
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'trade_smart');
    const url = 'https://swing.tradesmartonline.in';
    this.openTradeSmart()
    if (environment.app) {
      cordova.InAppBrowser.open(url, '_system', 'location=no');
    } else {
      this.windowRef.nativeWindow?.open(url, '_blank');
    }
  }

  getTradeUserDetail(query: any): Observable<any> {
    return this.http.get(`${API_END_POINTS.TRADE_SMART.signin}?${query}`);
  }
  tradeSmartLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.TRADE_SMART.login, data);
  }
  tradeSmartSignIn(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.TRADE_SMART.signin}`, data);
  }

  zerodhaOrderPlace(orders: any[]) {
    let path: string = this.getCurrentPath()
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'zerodha');
    if (environment.app) {
      const url = `https://pickright.in/callback/kite?type=basket_order&orders=${JSON.stringify(orders)}`
      if (environment.ios) {
        this.getFirebaseLink({ longDynamicLink: 'https://pickright.page.link/?link=' + encodeURIComponent(url) }).subscribe((res) => {
          cordova.InAppBrowser.open(res.data.shortLink, '_system', 'location=yes');
        })
      } else {
        const browser = cordova.InAppBrowser.open(url, '_blank', 'location=yes');
        browser.addEventListener('loadstart', (event) => {
          this.ngZone.runOutsideAngular(() => {
            this.ngZone.run(() => {
              const intentPath = "http://intent://pickright.page.link/?link="
              if (event.url.includes(intentPath)) {
                const decodePath = decodeURIComponent(event.url.substring(intentPath.length, event.url.indexOf("&apn")));
                const route = decodePath.replace("https://pickright.in", "")
                browser.close();
                this.dialogService.closeAll()
                this.router.navigateByUrl(`${route}`, { skipLocationChange: true });
              }
            })
          })
        });
      }
    } else {
      const ele = document.getElementById('zerodha-order');
      ele.innerHTML = `<form style="visibility: hidden;" method="post" id="basket-form" action="https://kite.zerodha.com/connect/basket">
          <input type="hidden" name="api_key" value="arcj8y6lo5xtusev" />
          <input type="hidden" id="basket" name="data" value="${orders}" />
        </form>`;
      const form = (document as any).getElementById('basket-form');
      (document as any).getElementById('basket').value = JSON.stringify(orders);
      form.submit();
    }
  }
  upstoxOrderPlace(orders: any[], accessToken: string, returnUrl: any) {
    let path: string = this.getCurrentPath()
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'upstox');
    if (environment.app) {
      const url = `${environment.webUrl}/redirect/upstock?isMobile=true&access=${accessToken}&orders=${JSON.stringify(orders)}&redirect=${returnUrl}`
      if (environment.ios) {
        this.getFirebaseLink({ longDynamicLink: 'https://pickright.page.link/?link=' + encodeURIComponent(url) }).subscribe((res) => {
          cordova.InAppBrowser.open(res.data.shortLink, '_system', 'location=yes');
        })
      } else {
        const browser = cordova.InAppBrowser.open(url, '_blank', 'location=yes');
        browser.addEventListener('loadstart', (event) => {
          this.ngZone.runOutsideAngular(() => {
            this.ngZone.run(() => {
              const intentPath = "http://intent://pickright.page.link/?link="
              if (event.url.includes(intentPath)) {
                const decodePath = decodeURIComponent(event.url.substring(intentPath.length, event.url.indexOf("&apn")));
                const route = decodePath.replace(environment.webUrl, "")
                browser.close();
                this.dialogService.closeAll()
                this.router.navigateByUrl(`${route}`, { skipLocationChange: true });
              }
            })
          })
        });
      }
    } else {
      const ele = document.getElementById('upstox-order');
      ele.innerHTML = `<form style="visibility: hidden;" method="post" id="basket-form" action="https://api-v2.upstox.com/uplink/order/place">         
        <input type="hidden" name="access_token" value="${accessToken}" />
        <input type="hidden" name="redirect_url" value="${environment.webUrl}${returnUrl}" />
        <input type="hidden" name="data" value="" id="order-data" />
          </form>`;
      const form = (document as any).getElementById('basket-form');
      (document as any).getElementById('order-data').value = JSON.stringify(orders);
      form.submit();
    }
  }

  zerodhaOrders(data): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.invest, data);
  }

  placeUpstoxOrders(data): Observable<any> {
    return this.http.post(API_END_POINTS.UPSTOX.placOrder, data);
  }

  updateLongtermOrders(query: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.ZERODHA.investpack_order_details}?${query}`)
  }

  updateShortTermOrder(query: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.ZERODHA.trading_order_details}?${query}`);
  }

  getCurrentPath(): string {
    let path: string = "";
    let currentPath = this.router.url.split('/')
    if (currentPath[currentPath.length - 1] === 'portfolio') {
      currentPath[currentPath.length - 1] = 'holdings'
    }
    let _pidx = currentPath.indexOf('partner');
    if (_pidx > -1) {
      currentPath.splice(_pidx, 2);
    }
    path = currentPath.join('_')
    if (path.includes('?')) {
      let idx = path.indexOf('?')
      path = path.slice(0, idx);
    }
    return path;
  }

  checkBrokerStatus(currentUser: any, currentBroker: any = '') {
    if (currentUser && currentUser.brokerageOptions.length) {
      currentBroker = currentBroker != '' ? currentBroker : currentUser.brokerageOptions[0];
      switch (currentBroker) {
        case 'alice_blue':
          if (
            currentUser.aliceblue.accessToken &&
            currentUser.aliceblue.expires &&
            !(new Date(currentUser.aliceblue.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'trade_smart':
          if (
            currentUser.tradesmart.appId &&
            currentUser.tradesmart.passKey &&
            !(new Date(currentUser.tradesmart.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'master_trust':
          if (
            currentUser.mastertrust.accessToken &&
            currentUser.mastertrust.expires &&
            !(new Date(currentUser.mastertrust.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'five_paisa':
          if (
            currentUser.fivepaisa.accessToken &&
            currentUser.fivepaisa.expires &&
            !(new Date(currentUser.fivepaisa.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'zerodha':
          if (
            currentUser.zerodha.accessToken &&
            currentUser.zerodha.expires &&
            !(new Date(currentUser.zerodha.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'aditya_birla':
          if (
            currentUser.adityaBirla.accessToken &&
            currentUser.adityaBirla.expires &&
            !(new Date(currentUser.adityaBirla.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'bajaj_finserv':
          if (
            currentUser.bajajFinserv.accessToken &&
            currentUser.bajajFinserv.expires &&
            !(new Date(currentUser.bajajFinserv.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'angel_broking':
          if (
            currentUser.angelBroking.accessToken &&
            currentUser.angelBroking.expires &&
            !(new Date(currentUser.angelBroking.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'nuvama':
          if (
            currentUser.nuvama.accessToken &&
            currentUser.nuvama.expires &&
            !(new Date(currentUser.nuvama.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'klever_trade':
          if (
            currentUser.kleverTrade.accessToken &&
            currentUser.kleverTrade.expires &&
            !(new Date(currentUser.kleverTrade.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'finvasia':
          if (
            currentUser.finvasia.accessToken &&
            currentUser.finvasia.expires &&
            !(new Date(currentUser.finvasia.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'ZEBU':
          if (
            currentUser.zebu.accessToken &&
            currentUser.zebu.expires &&
            !(new Date(currentUser.zebu.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'upstox':
          if (
            currentUser.upstox.accessToken &&
            currentUser.upstox.expires &&
            !(new Date(currentUser.upstox.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        case 'paytm':
          if (
            currentUser.paytm.accessToken &&
            currentUser.paytm.expires &&
            !(new Date(currentUser.paytm.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
          case 'ventura':
          if (
            currentUser.ventura.accessToken &&
            currentUser.ventura.expires &&
            !(new Date(currentUser.ventura.expires).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
          case 'kotak':
          if (
            currentUser.kotak.token &&
            currentUser.kotak.exp &&
            !(new Date(currentUser.kotak.exp).getTime() < new Date().getTime())
          ) {
            return true
          } else {
            return false
          }
        default:
          return false
      }
    } else {
      return false
    }
  }

  gotoBrokerLogin(broker: string) {
    this.analytics.logEvents('Login with Broker', { broker: broker })
    if (broker === 'alice_blue') {
      this.goToAliceBlue();
    } else if (broker === 'trade_smart') {
      this.goToTradeSmart();
    } else if (broker === 'master_trust') {
      this.goToMasterTrust();
    } else if (broker === 'five_paisa') {
      this.goToFivePaisa();
    } else if (broker === 'zerodha') {
      this.goToZerodha()
    } else if (broker === 'aditya_birla') {
      this.goToAdityaBirla()
    } else if (broker === 'bajaj_finserv') {
      this.goToBajajFinance()
    } else if (broker === 'nuvama') {
      this.goToEdelweiss()
    } else if (broker === 'angel_broking') {
      this.goToAngelBroking()
    } else if (broker === 'klever_trade') {
      this.goToKleverTrade()
    } else if (broker === 'finvasia') {
      this.goToFinvasia()
    } else if (broker === 'ZEBU') {
      this.goToZebu()
    } else if (broker === 'upstox') {
      this.goToUpstox()
    } else if (broker === 'paytm') {
      this.goToPaytm()
    } else if (broker === 'ventura'){
      this.goToVentura()
    }
    else if (broker === 'kotak') {
      this.goToKotak()
    }
  }

  handleRelogin(err, user) {
    const _code = err.error?.errorCode || err.error?.error?.errorCode || err.errorCode;
    const _msg = err.error?.message || err.error?.error?.message || err.message;
    this.analytics.logEvents('Broker Login Expired', { broker: user.brokerageOptions[0] })
    if (user.brokerageOptions.indexOf('five_paisa') > -1 &&
      (_code === 40011 || _msg === 'Too many incorrect attempts. Reset Password.' || _msg === 'Invalid login/password' ||
        _msg === 'You need to login, your 5Paisa account!e')) {
      this.gotoBrokerLogin('five_paisa')
    } else if (user.brokerageOptions.indexOf('trade_smart') > -1 &&
      (_code === 40011 || _msg === 'Authorization failed' || _msg === 'Invalid login/password')) {
      this.gotoBrokerLogin('trade_smart');
    } else if (user.brokerageOptions.indexOf('alice_blue') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000 || _msg === 'Request Unauthorised')
    ) {
      this.gotoBrokerLogin('alice_blue');
    } else if (user.brokerageOptions.indexOf('master_trust') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000)
    ) {
      this.gotoBrokerLogin('master_trust');
    } else if (user.brokerageOptions.indexOf('klever_trade') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000)
    ) {
      this.gotoBrokerLogin('klever_trade');
    } else if (user.brokerageOptions.indexOf('zerodha') > -1 &&
      err.error && (_code === 40011 || _msg === "No token found!" || _msg === 'Incorrect `api_key` or `access_token`.')
    ) {
      this.gotoBrokerLogin('zerodha');
    } else if (user.brokerageOptions.indexOf('aditya_birla') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000)
    ) {
      this.gotoBrokerLogin('aditya_birla');
    } else if (user.brokerageOptions.indexOf('nuvama') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000)
    ) {
      this.gotoBrokerLogin('nuvama');
    } else if (user.brokerageOptions.indexOf('angel_broking') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000)
    ) {
      this.gotoBrokerLogin('angel_broking');
    } else if (user.brokerageOptions.indexOf('bajaj_finserv') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000 || _code === 'EGN006')
    ) {
      this.gotoBrokerLogin('bajaj_finserv');
    } else if (user.brokerageOptions.indexOf('finvasia') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000)
    ) {
      this.gotoBrokerLogin('finvasia');
    }
    else if (user.brokerageOptions.indexOf('ZEBU') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000)
    ) {
      this.gotoBrokerLogin('ZEBU');
    }
    else if (user.brokerageOptions.indexOf('upstox') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000 || _msg === 'Request Unauthorised' || _msg === 'Invalid token used to access API')
    ) {
      this.gotoBrokerLogin('upstox');
    }
    else if (user.brokerageOptions.indexOf('paytm') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000 || _msg === 'Request Unauthorised' || _msg === 'Invalid token used to access API')
    ) {
      this.gotoBrokerLogin('paytm');
    }
     else if (user.brokerageOptions.indexOf('ventura') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000 || _msg === 'Request Unauthorised' || _msg === 'Invalid token used to access API')
    ) {
      this.gotoBrokerLogin('ventura');
    }
    else if (user.brokerageOptions.indexOf('kotak') > -1 &&
      err.error &&
      (_code === 40011 || _code === 40010 || _code === 40000 || _msg === 'Request Unauthorised' || _msg === 'Invalid token used to access API')
    ) {
      this.gotoBrokerLogin('kotak');
    }
  }

  openTradeSmart() {
    this.analytics.logEvents('Open Tradesmart Login', { action: 'open' })
    this.dialogService.openTradeSmartDialog().afterClosed().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.analytics.logEvents('Open Tradesmart Login', { action: 'close' })
          let brokerageDetails: any = {};
          brokerageDetails.name = res.data.name ? res.data.name : 'User';
          brokerageDetails.email = res.data.email ? res.data.email : '';
          brokerageDetails.accessToken = res.data.accessToken;
          brokerageDetails.uid = res.app.uid;
          brokerageDetails.appId = res.app.appId;
          brokerageDetails.appSecretKey = res.app.appSecretKey;
          brokerageDetails.passKey = res.app.passKey;
          this.goToLoginPage(brokerageDetails);
        }
      }
    });
  }

  async updateStateAfterLogin() {
    await this.auth.UpdateUserData(false)
    this.auth.checkAuth(false);
    this.goToAfterLogin();
  }

  goToAfterLogin() {
    let _path = this.windowRef.nativeWindow?.localStorage.getItem('currentPage');
    if (!_path) {
      _path = "_"
    }
    if (this.windowRef.nativeWindow?.sessionStorage.getItem('sai')) {
      this.windowRef.nativeWindow?.localStorage.removeItem('currentPage');
      this.windowRef.nativeWindow?.localStorage.removeItem('brokerage');
      let _advisor = this.windowRef.nativeWindow?.sessionStorage.getItem('sai');
      let _return = this.windowRef.nativeWindow?.sessionStorage.getItem('saireturnUrl');
      let _category = this.windowRef.nativeWindow?.sessionStorage.getItem('saicategory');
      if (_advisor) {
        let _extra = {};
        if (_category) {
          _extra = { queryParams: { category: _category } }
        }
        this.router.navigate([_return], _extra);
      }
    }
    else {
      let _path = this.windowRef.nativeWindow?.localStorage.getItem('currentPage');
      if (!_path) {
        _path = "_"
      }
      let page = _path.replace(/\_/g, '/');
      if (page == '/' || page == '/login') {
        page = '/products';
      }
      this.windowRef.nativeWindow?.localStorage.setItem('userVertical', 'investment');
      this.router.navigate([page]);
      // if (window.localStorage.getItem('subscription')) {
      //   window.localStorage.removeItem('subscription')
      // }
      // if (window.localStorage.getItem('portfolioBroker')) {
      //   window.localStorage.removeItem('portfolioBroker')
      // }
      this.windowRef.nativeWindow?.localStorage.removeItem('currentPage');
      this.windowRef.nativeWindow?.localStorage.removeItem('brokerage');
    }
    // if (this.windowRef.nativeWindow?.localStorage.getItem('subscription')) {
    //   this.windowRef.nativeWindow?.localStorage.removeItem('subscription')
    // }
    // if (this.windowRef.nativeWindow?.localStorage.getItem('portfolioBroker')) {
    //   this.windowRef.nativeWindow?.localStorage.removeItem('portfolioBroker')
    // }
    this.windowRef.nativeWindow?.localStorage.removeItem('currentPage');
    this.windowRef.nativeWindow?.localStorage.removeItem('brokerage');
  }

  goToLoginPage(brokrage: any) {
    this.windowRef.nativeWindow?.localStorage.setItem('brokrageDetail', JSON.stringify(brokrage));
    this.brokerDataChange(brokrage)
    if (brokrage !== 'tradesmart') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/login']);
      })
    }
  }

  placeBrokerOrder(callData: any, callId: string, broker: string, isBracket: boolean = false): Observable<any> {
    if (broker === 'alice_blue') {
      return isBracket ? this.aliceBlueBOorder(callId, callData) : this.aliceBlueOrder(callId, callData);
    } else if (broker === 'trade_smart') {
      return isBracket ? this.tradeSmartBOorder(callId, callData) : this.tradeSmartOrder(callId, callData);
    } else if (broker === 'master_trust') {
      return isBracket ? this.masterTrustBOorder(callId, callData) : this.masterTrustOrder(callId, callData);
    } else if (broker === 'five_paisa') {
      return this.fivePaisaOrder(callId, callData);
    } else if (broker === 'zerodha') {
      return isBracket ? this.zerodhaBOOrder(callId, callData) : this.zerodhaOrder(callId, callData)
    } else if (broker === 'aditya_birla') {
      return this.adityaBirlaOrder(callId, callData);
    } else if (broker === 'bajaj_finserv') {
      return this.bajajFinservOrder(callId, callData);
    } else if (broker === 'nuvama') {
      return this.edelweissOrder(callId, callData);
    } else if (broker === 'angel_broking') {
      return this.angelBrokingOrder(callId, callData);
    } else if (broker === 'klever_trade') {
      return this.kleverTradeOrder(callId, callData);
    }
  }

  placeStrategyBrokerOrder(callData: any, callId: string, broker: string): Observable<any> {
    if (broker === 'alice_blue') {
      return this.strategyAliceBlueOrder(callId, callData);
    } else if (broker === 'trade_smart') {
      return this.strategyTradeSmartOrder(callId, callData);
    } else if (broker === 'master_trust') {
      return this.strategyMasterTrustOrder(callId, callData);
    } else if (broker === 'five_paisa') {
      return this.strategyFivePaisaOrder(callId, callData);
    } else if (broker === 'zerodha') {
      return this.strategyZerodhaOrder(callId, callData);
    } else if (broker === 'aditya_birla') {
      return this.strategyAdityaBirlaOrder(callId, callData);
    } else if (broker === 'bajaj_finserv') {
      return this.strategyBajajFinanceOrder(callId, callData);
    } else if (broker === 'nuvama') {
      return this.edelweissOrder(callId, callData);
    } else if (broker === 'angel_broking') {
      return this.strategyAngelBrokingOrder(callId, callData);
    } else if (broker === 'klever_trade') {
      return this.strategyKleverTradeOrder(callId, callData);
    }
  }

  aliceBlueOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.ALICE_BLUE.placeOrder}/${id}`,
      data
    );
  }

  masterTrustOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.MASTER_TRUST.placeOrder}/${id}`,
      data
    );
  }

  tradeSmartOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.TRADE_SMART.placeOrder}/${id}`,
      data
    );
  }

  tradeSmartBOorder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.TRADE_SMART.bracket_order}/${id}`,
      data
    );
  }

  fivePaisaOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.FIVE_PAISA.placeOrder}/${id}`,
      data
    );
  }

  kleverTradeOrder(id, data): Observable<any> {
    return this.http.post(`${API_END_POINTS.KLEVER_TRADE.placeOrder}/${id}`, data)
  }

  adityaBirlaOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.ADITYA_BIRLA.placeOrder}/${id}`,
      data
    );
  }

  edelweissOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.EDELWEISS.placeOrder}/${id}`,
      data
    );
  }

  bajajFinservOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.BAJAJFINANCE.placeOrder}/${id}`,
      data
    );
  }

  angelBrokingOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.ANGELBROKING.placeOrder}/${id}`,
      data
    );
  }

  zerodhaOrder(id, data): Observable<any> {
    return this.http.post(`${API_END_POINTS.ZERODHA.placeOrder}/${id}`, data)
  }

  strategyAliceBlueOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.ALICE_BLUE.strategy_order}/${id}`,
      data
    );
  }

  strategyMasterTrustOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.MASTER_TRUST.strategy_order}/${id}`,
      data
    );
  }

  strategyTradeSmartOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.TRADE_SMART.strategy_order}/${id}`,
      data
    );
  }

  strategyFivePaisaOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.FIVE_PAISA.strategy_order}/${id}`,
      data
    );
  }

  strategyKleverTradeOrder(id, data): Observable<any> {
    return this.http.post(`${API_END_POINTS.KLEVER_TRADE.strategy_order}/${id}`, data)
  }

  strategyAdityaBirlaOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.ADITYA_BIRLA.strategy_order}/${id}`,
      data
    );
  }


  strategyEdelweissOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.EDELWEISS.strategy_order}/${id}`,
      data
    );
  }

  strategyAngelBrokingOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.ANGELBROKING.strategy_order}/${id}`,
      data
    );
  }

  strategyBajajFinanceOrder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.BAJAJFINANCE.strategy_order}/${id}`,
      data
    );
  }

  strategyZerodhaOrder(id, data): Observable<any> {
    return this.http.post(`${API_END_POINTS.ZERODHA.strategy_order}/${id}`, data)
  }

  aliceBlueBOorder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.ALICE_BLUE.bracket_order}/${id}`,
      data
    );
  }

  masterTrustBOorder(id, data): Observable<any> {
    return this.http.post(
      `${API_END_POINTS.MASTER_TRUST.bracket_order}/${id}`,
      data
    );
  }


  zerodhaBOOrder(id, data): Observable<any> {
    return this.http.post(`${API_END_POINTS.ZERODHA.bracket_order}/${id}`, data)
  }
  private goToFinvasia() {
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'finvasia');
    this.openFinvasia()
  }
  private goToZebu() {
    let path: string = this.getCurrentPath();
    const uri = `${API_END_POINTS.ZEBU.redirect}?state=${this.callbackPage}`;
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'ZEBU');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    if (environment.app) {
      cordova.InAppBrowser.open(uri, '_system', 'location=yes');
    } else {
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }
  zebuLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ZEBU.login, data);
  }
  zebySignin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ZEBU.signin, data);
  }

  openFinvasia() {
    this.analytics.logEvents('Open Finvasia Login', { action: 'open' })
    this.dialogService.openFinvasiaDialog().afterClosed().subscribe((res) => {
      if (res && res.data) {
        this.analytics.logEvents('Open Finvasia Login', { action: 'close' })
        let brokerageDetails: any = {}
        brokerageDetails = res.data
        this.goToLoginPage(brokerageDetails);
      }
    })
  }

  finvasiasignIn(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.FINVASIA.signin, data);
  }

  finvasiaLogIn(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.FINVASIA.login, data)
  }

  zebuSignIn(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ZEBU.signin, data);
  }

  zebuLogIn(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.ZEBU.login, data)
  }

  brokerDataChange(value) {
    this.brokerDetailsChanged.next(value)
  }

  isBrokerDataChanged(): Observable<any> {
    return this.brokerDetailsChanged.asObservable()
  }

  getFirebaseLink(data): Observable<any> {
    return this.http.post(API_END_POINTS.FIREBASE.dynamic_link, data);
  }

  private goToUpstox() {
    let path: string = this.getCurrentPath();
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'upstox');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    if (environment.app) {
      const url = `${environment.webUrl}/redirect/upstock?isMobile=true`;
      if (environment.ios) {
        cordova.InAppBrowser.open(url, '_system', 'location=yes');
      } else {
        const browser = cordova.InAppBrowser.open(url, '_blank', 'location=yes');
        browser.addEventListener('loadstart', (event) => {
          const intentPath = "http://intent://pickright.page.link/?link="
          if (event.url.includes(intentPath)) {
            const decodePath = decodeURIComponent(event.url.substring(intentPath.length, event.url.indexOf("&apn")));
            const route = decodePath.replace(environment.webUrl, "")
            browser.close();
            this.router.navigateByUrl(`${route}`, { skipLocationChange: true });
          }
        });
      }
    } else {
      const uri = `${API_END_POINTS.UPSTOX.client_url}?state=${this.callbackPage}`;
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }

  upstoxLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.UPSTOX.login, data);
  }
  upstoxSignIn(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.UPSTOX.signin}`, data);
  }
  private goToPaytm() {
    let path: string = this.getCurrentPath();
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'paytm');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
    if (environment.app) {
      const url = `${environment.webUrl}/callback/paytmmoney?isMobile=true`;
      if (environment.ios) {
        cordova.InAppBrowser.open(url, '_system', 'location=yes');
      } else {
        const browser = cordova.InAppBrowser.open(url, '_blank', 'location=yes');
        browser.addEventListener('loadstart', (event) => {
          const intentPath = "http://intent://pickright.page.link/?link="
          if (event.url.includes(intentPath)) {
            const decodePath = decodeURIComponent(event.url.substring(intentPath.length, event.url.indexOf("&apn")));
            const route = decodePath.replace("https://pickright.in", "")
            browser.close();
            this.router.navigateByUrl(`${route}`, { skipLocationChange: true });
          }
        });
      }
    } else {
      const uri = `${API_END_POINTS.PAYTM.redirect}?state=${this.callbackPage}`;
      this.windowRef.nativeWindow?.open(uri, '_self');
    }
  }

  paytmLogin(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.PAYTM.login, data);
  }
  paytmSignIn(data: any): Observable<any> {
    return this.http.post(`${API_END_POINTS.PAYTM.signin}`, data);
  }

fetchVenturaProfile() {
    const requestToken = this.activatedRoute.snapshot.queryParamMap.get('request_token');
    const deviceToken = this.windowRef.nativeWindow?.localStorage.getItem('deviceToken') || ''; 
    const platform = environment.app ? (environment.ios ? 'ios' : 'android') : 'web';
    this.http.post(API_END_POINTS.VENTURA.getProfile, {
      "requestToken": requestToken,
      "deviceToken": deviceToken,
      "platform": platform
    }).subscribe((res: any) => {
      if (res) {
        const brokerageDetails = {
          access_token: res.access_token,
          expires_in: res.expires_in,
          clientId: res.client_id
        };
        this.auth.saveAccessToken(brokerageDetails);
        this.getUserProfile()
        this.router.navigateByUrl('/');
      }
    });
  }

  getUserProfile() {
          this.auth.getUserProfile().subscribe((res: any) => {
              res.data.scope = 'investor';
              window.localStorage.setItem('userProfile', JSON.stringify(res.data));
              timer(10).subscribe(() => {
                  this.auth.checkAuth(true);
              });
          });
      }

  goToVentura() {
    const path: string = this.getCurrentPath();
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'ventura');
    this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);

    this.http.get(API_END_POINTS.VENTURA.client, { responseType: 'text' }).subscribe({
      next: (loginUrl: string) => {
        if (!loginUrl.startsWith('http')) {
          console.error('Unexpected Ventura login URL format:', loginUrl);
          return;
        }

        if (environment.app) {
          if (environment.ios) {
            cordova.InAppBrowser.open(loginUrl, '_system', 'location=yes');
          } else {
            const browser = cordova.InAppBrowser.open(loginUrl, '_blank', 'location=yes');
            browser.addEventListener('loadstart', (event) => {
              const intentPath = "http://intent://pickright.page.link/?link=";
              if (event.url.includes(intentPath)) {
                const decodePath = decodeURIComponent(
                  event.url.substring(intentPath.length, event.url.indexOf("&apn"))
                );
                const route = decodePath.replace("https://pickright.in", "");
                browser.close();
                this.router.navigateByUrl(`${route}`);
              }
            });
          }
        } else {
          this.windowRef.nativeWindow?.open(loginUrl, '_self');
        }
      },
      error: (err) => {
        console.error('Failed to get Ventura login URL:', err);
      }
    });
  }

   saveAccessToken(brokerageDetails: any) {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(environment.tokenKey, JSON.stringify(brokerageDetails));
      this.router.navigate(['/']);
    }
  }
venturaOrders(data): Observable<any> {
    return this.http.post(API_END_POINTS.INVESTOR_LONGTERM.invest, data); 
}

venturaOrderPlace(orders: any[], appKey: string, clientId: string, accessToken: string, basketIds: string[]) {
  const path: string = this.getCurrentPath();
  this.windowRef.nativeWindow?.localStorage.setItem('currentPage', path);
  this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'ventura');
  this.windowRef.nativeWindow?.localStorage.setItem('venturaAccessToken', accessToken);
  this.windowRef.nativeWindow?.localStorage.setItem('venturaClientId', clientId);
  this.windowRef.nativeWindow?.localStorage.setItem('venturaAppKey', appKey);
  this.windowRef.nativeWindow?.localStorage.setItem('venturaBaskets', JSON.stringify(basketIds));

  if (!Array.isArray(basketIds)) {
    basketIds = basketIds ? [basketIds] : [];
  }
  if (!basketIds.length) {
    console.error('No valid Ventura basket IDs found.');
    return;
  }
  
  const firstBasketId = basketIds[0];
  const redirectTo = `https://pickright.in/callback/ventura/?basketIndex=1`;

  this.openVenturaBasket(firstBasketId, clientId, appKey, accessToken, redirectTo);
}

openVenturaBasket(basketId: string, clientId: string, appKey: string, accessToken: string, redirectTo: string): void {
  const baseUrl = `https://easeapi.venturasecurities.com/order/order-ui/v1/order-confirmation`;
  const urlWithParams = `${baseUrl}?basket_id=${basketId}&client_id=${clientId}&app_key=${appKey}&auth_token=${accessToken}&redirect_to=${redirectTo}`;

  if (environment.app) {
    if (environment.ios) {
      this.getFirebaseLink({ longDynamicLink: 'https://pickright.page.link/?link=' + encodeURIComponent(urlWithParams) }).subscribe((res: any) => {
        cordova.InAppBrowser.open(res.data.shortLink, '_system', 'location=yes');
      });
    } else {
      const browser = cordova.InAppBrowser.open(urlWithParams, '_blank', 'location=yes');
      browser.addEventListener('loadstart', (event) => {
        const intentPath = "http://intent://pickright.page.link/?link=";
        if (event.url.includes(intentPath)) {
          const decodePath = decodeURIComponent(event.url.substring(intentPath.length, event.url.indexOf("&apn")));
          const route = decodePath.replace("https://pickright.in", "");
          browser.close();
          this.router.navigateByUrl(`${route}`);
        }
      });
    }
  } else {
    const ele = document.getElementById('ventura-order');
    if (ele) {
      ele.innerHTML = `
        <form style="visibility: hidden;" method="get" id="basket-form" action="${baseUrl}">
          <input type="hidden" name="basket_id" value="${basketId}" />
          <input type="hidden" name="client_id" value="${clientId}" />
          <input type="hidden" name="app_key" value="${appKey}" />
          <input type="hidden" name="auth_token" value="${accessToken}" />
          <input type="hidden" name="redirect_to" value="${redirectTo}" />
        </form>`;
      const form = (document as any).getElementById('basket-form');
      form.submit();
    } else {
      console.warn('Element with ID "ventura-order" not found in DOM.');
    }
  }
}



private getAccessToken(): string {
    const brokerageDetails = JSON.parse(this.windowRef.nativeWindow?.localStorage.getItem(environment.tokenKey) || '{}');
    return brokerageDetails.access_token || '';
}
getVenturaTokenInfo(token: any): Observable<any> {
    return this.http.post(API_END_POINTS.VENTURA.getProfile, { requestToken: token });
  }
getBasketDetails(){
  return this.http.get(`${API_END_POINTS.VENTURA.basket_details}`)
}
kotakLogin(data:any): Observable<any> {
    return this.http.post(API_END_POINTS.KOTAK.login, data);
  }
  kotakVerifyOtp(data: any, sid: string, authToken: string): Observable<any> {
    return this.http.post(API_END_POINTS.KOTAK.verifyOtp,data);
  }

  openKotak() {
    this.analytics.logEvents('Open Kotak Login', { action: 'open' })
    this.dialogService.openKotakaDialog().afterClosed().subscribe((res) => {
      if (res && res.data) {
        this.analytics.logEvents('Open Kotak Login', { action: 'close' })
        let brokerageDetails: any = {}
        brokerageDetails = res.data
        this.goToLoginPage(brokerageDetails);
      }
    })
  }
  private goToKotak() {
    this.windowRef.nativeWindow?.localStorage.setItem('brokerage', 'kotak');
    this.openKotak()
  }
}
